<template>
  <div class="table-container">
    <ABTable :columns="columns" :tableData="rows" :page-title="pageTitle" :showCreateButton="false"
      :hasDetailsPage="false" :hasEditPage="false" :noActions="true" :isLoading="isLoading"
      :page="remoteParams.page" :pageSize="remoteParams.pageSize" :totalCount="totalCount"
      @onFetchRemoteData="fetchRemoteData" class="styled-table">
      <template #tableHeader="{ columns }">
        <thead>
          <tr>
            <th v-for="column in columns" :key="column.field">{{ column.label }}</th>
          </tr>
        </thead>
      </template>

      <template #tableBody="{ rows, columns }">
        <tbody>
          <tr v-for="row in rows" :key="row.id" @click="handleRowClick(row)" class="clickable-row">
            <td v-for="column in columns" :key="column.field">
              {{ row[column.field] }}
            </td>
          </tr>
        </tbody>
      </template>

      <template #loading><div class="loading-text">Loading...</div></template>
      <template #noData><div class="no-data-text">No Data Available</div></template>
    </ABTable>
  </div>
</template>

<script>
import ABTable from '@/components/ABTable.vue';
import { useDeliveryNotePrintedStore } from '@/stores/deliveryNotePrinted.js';
import { useToast } from 'vue-toast-notification';
const $toast = useToast();

export default {
  name: 'ReturnedToSupplierTable',
  components: { ABTable },
  data() {
    return {
      remoteParams: { page: 1, pageSize: 10, sortBy: 'Id', sortDirection: 'desc', searchQuery: '' },
      isLoading: false,
      pageTitle: 'Returned to Supplier',
      columns: [
        { label: 'Return Note #', field: 'returnNoteNumber' },
        { label: 'Bags',          field: 'bagNumbers' },
        { label: 'Date',          field: 'createdDate' },
      ],
      rows: [],
      totalCount: 0,
    };
  },
  mounted() {
    this.fetchRemoteData({ page: 1, pageSize: this.remoteParams.pageSize });
  },
  methods: {
    async fetchRemoteData(remoteParams) {
      this.remoteParams = { ...this.remoteParams, ...remoteParams };
      this.isLoading = true;
      const store = useDeliveryNotePrintedStore();
      try {
        const response = await store.searchReturnNotes(
          this.remoteParams.page,
          this.remoteParams.pageSize,
          this.remoteParams.sortBy,
          this.remoteParams.sortDirection,
          this.remoteParams.searchQuery
        );
        if (response && response.items) {
          this.rows = response.items.map(r => ({
            ...r,
            returnNoteNumber: r.returnNoteNumber ? `R${r.returnNoteNumber}` : `#${r.id}`,
            bagNumbers: r.bagNumbers ? r.bagNumbers.join(', ') : '',
            createdDate: r.createdDate ? new Date(r.createdDate).toLocaleDateString('en-GB') : '',
          }));
          this.totalCount = response.totalCount || 0;
        } else {
          this.rows = [];
          this.totalCount = 0;
        }
      } catch (e) {
        $toast.error('Failed to load return notes');
        this.rows = [];
      }
      this.isLoading = false;
    },

    handleRowClick(row) {
      this.$router.push(`/returnNoteDetails/${row.id}`);
    },
  },
};
</script>

<style scoped>
.table-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
}
.styled-table { width: 80%; max-width: 1000px; }
.styled-table th { background-color: #008cba; color: white; font-weight: bold; text-align: center; padding: 12px; }
.styled-table td { text-align: center; padding: 12px; border-bottom: 1px solid #ddd; }
.clickable-row { cursor: pointer; transition: background-color 0.2s ease-in-out; }
.clickable-row:hover { background-color: #f1f1f1; }
.loading-text, .no-data-text { text-align: center; padding: 20px; font-size: 16px; color: #555; }
</style>
